import React from 'react';
import { Shield } from 'lucide-react';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-white">
      <section className="bg-gradient-to-b from-black via-gray-900 to-black py-20 px-4">
        <div className="container mx-auto text-center">
          <Shield className="mx-auto text-yellow-400 mb-6" size={64} />
          <h1 className="text-5xl md:text-7xl font-black text-white mb-6">
            Privacy Policy
          </h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Last updated: January 2025
          </p>
        </div>
      </section>

      <section className="py-16 px-4">
        <div className="container mx-auto max-w-4xl">
          <div className="prose prose-lg max-w-none">
            <h2 className="text-3xl font-bold text-black mb-6">1. Introduction</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [This is placeholder text for the Privacy Policy. The actual privacy policy content will be added by bHyyve legal team. 
              This document will outline how bHyyve collects, uses, stores, and protects user data in compliance with Canadian privacy 
              laws including PIPEDA (Personal Information Protection and Electronic Documents Act).]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">2. Information We Collect</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will detail what types of personal information bHyyve collects from users, 
              including account information, booking details, payment information, device information, and usage data.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">3. How We Use Your Information</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will explain how bHyyve uses collected information to provide services, 
              process bookings, communicate with users, improve the platform, and ensure security.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">4. Information Sharing and Disclosure</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will describe when and how bHyyve shares information with service providers, 
              business partners, and authorities when required by law.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">5. Data Security</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will outline the security measures bHyyve implements to protect user data, 
              including encryption, secure servers, and access controls.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">6. Your Rights and Choices</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will explain users' rights regarding their personal data, including access, 
              correction, deletion, and opt-out options.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">7. Cookies and Tracking Technologies</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will describe how bHyyve uses cookies and similar technologies for analytics, 
              personalization, and advertising.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">8. Children's Privacy</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will state that bHyyve services are not intended for children under 18 and 
              outline protections for minors' data.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">9. Changes to This Policy</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              [Placeholder content: This section will explain how users will be notified of changes to the privacy policy 
              and when the changes become effective.]
            </p>

            <h2 className="text-3xl font-bold text-black mb-6">10. Contact Us</h2>
            <p className="text-gray-700 leading-relaxed mb-8">
              If you have questions about this Privacy Policy, please contact us at:
            </p>
            <div className="bg-gray-50 border-2 border-gray-200 rounded-xl p-6 mb-8">
              <p className="text-gray-700 mb-2"><strong>Email:</strong> privacy@bhyyve.com</p>
              <p className="text-gray-700 mb-2"><strong>Mail:</strong> bHyyve Inc., 123 Service Street, Toronto, ON M5V 1A1</p>
              <p className="text-gray-700"><strong>Phone:</strong> +1 (555) 000-0000</p>
            </div>

            <div className="bg-yellow-400/20 border-2 border-yellow-400 rounded-xl p-6">
              <p className="text-black font-semibold">
                <strong>Note:</strong> This is a placeholder document. The final privacy policy will be drafted by legal counsel 
                to ensure full compliance with Canadian privacy laws and regulations.
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default PrivacyPolicy;